import React from 'react';
import { Clock, Download, Smartphone, AlertCircle, Zap, BookOpen, CalendarCheck, Send, Calculator, Tag, Search, Award, Sparkles, Lock } from 'lucide-react';
export function InstantDelivery() {
  return <section className="py-12 md:py-16 px-4 md:px-6 bg-white border-y border-[#e0bfb4]/30 relative overflow-hidden" data-id="element-78">
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#b8956a] opacity-5 rounded-full blur-lg md:blur-2xl -translate-x-1/2 -translate-y-1/2 pointer-events-none will-change-transform" data-id="element-79" />
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#7a9a6b] opacity-5 rounded-full blur-lg md:blur-2xl translate-x-1/2 translate-y-1/2 pointer-events-none will-change-transform" data-id="element-80" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-81">
        {/* Header */}
        <div className="text-center mb-8 md:mb-10" data-id="element-82">
          <div className="inline-flex items-center justify-center gap-2 px-4 py-1.5 bg-[#b8956a]/10 text-[#b8956a] rounded-full text-sm font-bold mb-4" data-id="element-83">
            <Zap className="w-4 h-4 fill-current" data-id="element-84" />
            <span data-id="element-85">LO RECIBES HOY</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#3d2b1f] leading-tight" data-id="element-86">
            Todo lo que necesitas para empezar, entregado al instante.
          </h2>

          {/* 3-step flow */}
          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-0" data-id="element-87">
            <div className="flex items-center gap-2.5" data-id="element-88">
              <div className="w-9 h-9 rounded-full bg-[#b8956a] text-white flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-89">
                1
              </div>
              <span className="text-sm md:text-base font-bold text-[#3d2b1f]" data-id="element-90">
                Realizas un unico pago
              </span>
            </div>
            <div className="hidden sm:block text-[#b8956a] text-xl font-bold mx-3" data-id="element-91">
              →
            </div>
            <div className="sm:hidden text-[#b8956a] text-lg font-bold" data-id="element-92">↓</div>
            <div className="flex items-center gap-2.5" data-id="element-93">
              <div className="w-9 h-9 rounded-full bg-[#b8956a] text-white flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-94">
                2
              </div>
              <span className="text-sm md:text-base font-bold text-[#3d2b1f]" data-id="element-95">
                Te llega un email en 2 minutos
              </span>
            </div>
            <div className="hidden sm:block text-[#b8956a] text-xl font-bold mx-3" data-id="element-96">
              →
            </div>
            <div className="sm:hidden text-[#b8956a] text-lg font-bold" data-id="element-97">↓</div>
            <div className="flex items-center gap-2.5" data-id="element-98">
              <div className="w-9 h-9 rounded-full bg-[#b8956a] text-white flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-99">
                3
              </div>
              <span className="text-sm md:text-base font-bold text-[#3d2b1f]" data-id="element-100">
                Abres desde tu celular. Listo.
              </span>
            </div>
          </div>
        </div>

        {/* Product Showcase Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 mb-6" data-id="element-101">
          {/* Card 1 — Guía Principal */}
          <div className="bg-[#faf6f1] rounded-2xl p-4 md:p-5 border border-[#e0bfb4]/40 flex flex-col items-center text-center" data-id="element-102">
            <div className="w-11 h-11 rounded-full bg-[#b8956a]/15 flex items-center justify-center mb-3" data-id="element-103">
              <BookOpen className="w-5 h-5 text-[#b8956a]" data-id="element-104" />
            </div>
            <h3 className="font-bold text-[#3d2b1f] text-xs md:text-sm leading-tight mb-2" data-id="element-105">
              Freelance Desde Cero (Sin Ingles)
            </h3>
            <div className="mt-auto" data-id="element-106">
              <span className="text-[#9a8b7a] line-through text-xs" data-id="element-107">$47</span>
              <span className="block text-[#7a9a6b] font-bold text-[11px] mt-0.5" data-id="element-108">
                INCLUIDO
              </span>
            </div>
          </div>

          {/* Card 2 — Plan 7 Días */}
          <div className="bg-[#faf6f1] rounded-2xl p-4 md:p-5 border border-[#e0bfb4]/40 flex flex-col items-center text-center" data-id="element-109">
            <div className="w-11 h-11 rounded-full bg-[#7a9a6b]/15 flex items-center justify-center mb-3" data-id="element-110">
              <CalendarCheck className="w-5 h-5 text-[#7a9a6b]" data-id="element-111" />
            </div>
            <h3 className="font-bold text-[#3d2b1f] text-xs md:text-sm leading-tight mb-2" data-id="element-112">
              El Plan 7 Dias "Primer Dinero"
            </h3>
            <div className="mt-auto" data-id="element-113">
              <span className="text-[#9a8b7a] line-through text-xs" data-id="element-114">$17</span>
              <span className="block text-[#7a9a6b] font-bold text-[11px] mt-0.5" data-id="element-115">
                INCLUIDO
              </span>
            </div>
          </div>

          {/* Card 3 — 50 Mensajes */}
          <div className="bg-[#faf6f1] rounded-2xl p-4 md:p-5 border border-[#e0bfb4]/40 flex flex-col items-center text-center" data-id="element-116">
            <div className="w-11 h-11 rounded-full bg-[#c47a6a]/15 flex items-center justify-center mb-3" data-id="element-117">
              <Send className="w-5 h-5 text-[#c47a6a]" data-id="element-118" />
            </div>
            <h3 className="font-bold text-[#3d2b1f] text-xs md:text-sm leading-tight mb-2" data-id="element-119">
              50 Mensajes "Copia y Pega"
            </h3>
            <div className="mt-auto" data-id="element-120">
              <span className="text-[#9a8b7a] line-through text-xs" data-id="element-121">$17</span>
              <span className="block text-[#7a9a6b] font-bold text-[11px] mt-0.5" data-id="element-122">
                INCLUIDO
              </span>
            </div>
          </div>

          {/* Card 4 — Calculadora Express */}
          <div className="bg-[#faf6f1] rounded-2xl p-4 md:p-5 border border-[#e0bfb4]/40 flex flex-col items-center text-center" data-id="element-123">
            <div className="w-11 h-11 rounded-full bg-[#b8956a]/15 flex items-center justify-center mb-3" data-id="element-124">
              <Calculator className="w-5 h-5 text-[#b8956a]" data-id="element-125" />
            </div>
            <h3 className="font-bold text-[#3d2b1f] text-xs md:text-sm leading-tight mb-2" data-id="element-126">
              Calculadora Express de Precios
            </h3>
            <div className="mt-auto" data-id="element-127">
              <span className="text-[#9a8b7a] line-through text-xs" data-id="element-128">$9</span>
              <span className="block text-[#7a9a6b] font-bold text-[11px] mt-0.5" data-id="element-129">
                INCLUIDO
              </span>
            </div>
          </div>

          {/* Card 5 — Tabla de Precios */}
          <div className="bg-[#faf6f1] rounded-2xl p-4 md:p-5 border border-[#e0bfb4]/40 flex flex-col items-center text-center" data-id="element-130">
            <div className="w-11 h-11 rounded-full bg-[#7a9a6b]/15 flex items-center justify-center mb-3" data-id="element-131">
              <Tag className="w-5 h-5 text-[#7a9a6b]" data-id="element-132" />
            </div>
            <h3 className="font-bold text-[#3d2b1f] text-xs md:text-sm leading-tight mb-2" data-id="element-133">
              Tabla de Precios Inteligente
            </h3>
            <div className="mt-auto" data-id="element-134">
              <span className="text-[#9a8b7a] line-through text-xs" data-id="element-135">$9</span>
              <span className="block text-[#7a9a6b] font-bold text-[11px] mt-0.5" data-id="element-136">
                INCLUIDO
              </span>
            </div>
          </div>

          {/* Card 6 — Lista Secreta */}
          <div className="bg-[#faf6f1] rounded-2xl p-4 md:p-5 border border-[#e0bfb4]/40 flex flex-col items-center text-center" data-id="element-137">
            <div className="w-11 h-11 rounded-full bg-[#c47a6a]/15 flex items-center justify-center mb-3" data-id="element-138">
              <Search className="w-5 h-5 text-[#c47a6a]" data-id="element-139" />
            </div>
            <h3 className="font-bold text-[#3d2b1f] text-xs md:text-sm leading-tight mb-2" data-id="element-140">
              La Lista Secreta: 50 Negocios
            </h3>
            <div className="mt-auto" data-id="element-141">
              <span className="text-[#9a8b7a] line-through text-xs" data-id="element-142">$17</span>
              <span className="block text-[#7a9a6b] font-bold text-[11px] mt-0.5" data-id="element-143">
                INCLUIDO
              </span>
            </div>
          </div>

          {/* Card 7 — Kit Credibilidad (NUEVO) */}
          <div className="bg-gradient-to-br from-[#b8956a]/10 to-[#c47a6a]/10 rounded-2xl p-4 md:p-5 border-2 border-[#c47a6a]/40 flex flex-col items-center text-center relative col-span-2 md:col-span-1" data-id="element-144">
            <span className="absolute -top-2.5 right-3 bg-[#c47a6a] text-white text-[9px] font-bold px-2.5 py-0.5 rounded-full tracking-wider uppercase flex items-center gap-1" data-id="element-145">
              <Sparkles className="w-2.5 h-2.5" data-id="element-146" />
              NUEVO
            </span>
            <div className="w-11 h-11 rounded-full bg-[#c47a6a]/20 flex items-center justify-center mb-3" data-id="element-147">
              <Award className="w-5 h-5 text-[#c47a6a]" data-id="element-148" />
            </div>
            <h3 className="font-bold text-[#3d2b1f] text-xs md:text-sm leading-tight mb-2" data-id="element-149">
              Kit Credibilidad Instantanea
            </h3>
            <div className="mt-auto" data-id="element-150">
              <span className="text-[#9a8b7a] line-through text-xs" data-id="element-151">$27</span>
              <span className="block text-[#7a9a6b] font-bold text-[11px] mt-0.5" data-id="element-152">
                INCLUIDO
              </span>
            </div>
          </div>
        </div>

        {/* Value Summary Bar */}
        <div className="bg-[#faf6f1] rounded-2xl p-4 md:p-5 border border-[#e0bfb4]/40 mb-6" data-id="element-153">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4" data-id="element-154">
            <div className="flex items-center gap-2" data-id="element-155">
              <span className="text-[#6b5744] font-medium text-sm" data-id="element-156">
                Valor total:
              </span>
              <span className="text-[#9a8b7a] line-through text-lg font-bold" data-id="element-157">
                $197 USD
              </span>
            </div>
            <div className="hidden sm:block text-[#b8956a] font-bold text-lg" data-id="element-158">
              →
            </div>
            <div className="sm:hidden text-[#b8956a] font-bold text-base" data-id="element-159">
              ↓
            </div>
            <div className="flex items-center gap-2" data-id="element-160">
              <span className="text-[#3d2b1f] font-bold text-sm" data-id="element-161">
                Tu precio hoy:
              </span>
              <span className="text-[#b8956a] font-extrabold text-2xl" data-id="element-162">
                $14 USD
              </span>
            </div>
          </div>
        </div>

        {/* Inbox note */}
        <div className="bg-[#faf6f1] rounded-2xl p-4 md:p-5 border border-[#e0bfb4]/40 mb-8" data-id="element-163">
          <div className="flex items-start gap-3" data-id="element-164">
            <AlertCircle className="w-5 h-5 text-[#9a8b7a] flex-shrink-0 mt-0.5" data-id="element-165" />
            <div data-id="element-166">
              <p className="text-sm text-[#6b5744] font-medium" data-id="element-167">
                Si no lo ves en tu inbox, revisa "Promociones/Spam".
              </p>
              <p className="text-sm text-[#6b5744] font-medium mt-2" data-id="element-168">
                Si sabes usar WhatsApp, ya tienes lo basico. El mapa te dice que
                hacer paso a paso.
              </p>
            </div>
          </div>
        </div>

        {/* Mini Price + CTA Block */}
        <div className="bg-[#3d2b1f] rounded-3xl p-6 md:p-8 text-center" data-id="element-169">
          <p className="text-[#d4b896] text-sm font-medium mb-2" data-id="element-170">
            Tu precio hoy:
          </p>
          <div className="flex items-center justify-center gap-3 mb-3" data-id="element-171">
            <span className="text-[#9a8b7a] line-through text-lg" data-id="element-172">$197</span>
            <span className="text-4xl md:text-5xl font-extrabold text-white" data-id="element-173">
              $14 <span className="text-lg text-[#d4b896]" data-id="element-174">USD</span>
            </span>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs md:text-sm text-[#d4b896] font-medium mb-5" data-id="element-175">
            <span className="flex items-center gap-1.5" data-id="element-176">
              <Zap className="w-3.5 h-3.5 text-[#b8956a]" data-id="element-177" />
              Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-178">
              <Clock className="w-3.5 h-3.5 text-[#b8956a]" data-id="element-179" />
              Garantia 7 dias
            </span>
            <span className="flex items-center gap-1.5" data-id="element-180">
              <Download className="w-3.5 h-3.5 text-[#b8956a]" data-id="element-181" />
              Pago unico
            </span>
          </div>
          <a href="#offer" className="inline-flex px-8 py-4 bg-[#b8956a] hover:bg-[#c9a87a] text-[#3d2b1f] font-bold text-base md:text-lg rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 items-center justify-center gap-2" data-id="element-182">
            Sí, quiero conseguir mi primer cliente — $14
          </a>
        </div>
      </div>
    </section>;
}